<div class="lobby-container">
    <div class="lobby-content">
        <div class="header-container">
            <img alt="KCDice Logo" class="logo" src="/images/logo.png" />
            <h1>KCDice</h1>
            <game-instructions-help title="KCDice Rules" />
        </div>

        <form (ngSubmit)="onSubmit()" [formGroup]="lobbyForm">
            <div class="form-group">
                <label for="playerName">Player Name*</label>
                <input formControlName="playerName" id="playerName" placeholder="Enter your nickname" type="text" />
                @if (lobbyForm.get("playerName")?.invalid && lobbyForm.get("playerName")?.touched) {
                    <div class="form-error">Player name is required</div>
                }
            </div>

            <div class="form-group">
                <label for="roomId">Room</label>
                <div class="room-group">
                    <input formControlName="roomId" id="roomId" placeholder="Enter room or leave empty" type="text" />
                    <button
                        (click)="generateRoomCode()"
                        class="generate-btn"
                        title="Generate a room code"
                        type="button"
                    >
                        Generate
                    </button>
                </div>
            </div>

            <div class="action-buttons">
                <button
                    [disabled]="lobbyForm.invalid || !isConnected()"
                    [title]="!isConnected() ? 'Server is offline. Try again later.' : ''"
                    class="primary"
                    type="submit"
                >
                    Join Room
                </button>
            </div>
        </form>

        <div class="recent-rooms">
            <h3>Recent Rooms</h3>
            @for (room of roomList(); track room.roomId) {
                <ul>
                    <li>
                        {{ room.roomId }}
                        @if (room.started) {
                            <ng-icon name="lucideDot" color="red" />
                        }
                        <button (click)="quickJoin(room.roomId)">Join</button>
                    </li>
                </ul>
            } @empty {
                <p>No rooms yet</p>
            }
        </div>
    </div>
</div>

<div id="kofi-container"></div>
